import squashKind from './squash-kind';

// The catalog descriptions guide the model; this copy is what people read.
const TOOL_SUMMARIES: Record<string, string> = {
  baselayer: 'Business search with derived KYB risk signals.',
  browser: 'Drives a browser through vendor portals, registries, and sites that need a login or a bot check.',
  entity_duplicates:
    'Other entities at your organization sharing PII or a device, with their status, label, tags, onboardings, and device insights.',
  comply_advantage_screening:
    'Screens a person against sanctions, PEP, and adverse-media watchlists, with per-category hits.',
  grail_pay_account_intelligence: 'US bank-account verification with a confidence score and decisioning insights.',
  idology_expect_id: 'Identity verification with risk signals.',
  incode_ekyb_cn: 'Verifies a China-registered business: name, tax ID, address, and beneficial owners.',
  incode_ekyc_ca_fintrac:
    'Matches name, date of birth, and address against credit-bureau records, with the credit file number FINTRAC requires.',
  incode_ekyc_ca_res_credit: 'Matches name, date of birth, address, and phone against residential and credit records.',
  lexis_flex_id: 'Identity verification with risk signals.',
  osint: 'Web search and page reading for open-source research, with citations.',
  sentilink_application_risk: 'Synthetic-identity and ID-theft scoring for an application.',
  sentilink_first_party_fraud: 'First-party fraud scoring for an application.',
  sumsub_applicant_fetch: 'A complete snapshot of one applicant: status, documents, AML case, risk labels, timeline.',
  sumsub_applicant_write: 'Adds a case note or appends tags to an applicant.',
  sumsub_document_fetch: 'Downloads chosen documents from an applicant for review.',
  sumsub_document_list: 'The documents an applicant uploaded, with their type and review result.',
  trans_union_tru_vision_resident_screening: 'Credit, criminal, and eviction recommendations for a rental applicant.',
  trustfull_onboarding: 'Digital-footprint score from email, phone, IP, and name, with risk and trust reason codes.',
  twilio: 'Line type, carrier, and phone risk signals.',
  unit21_alert_fetch: 'The full record for one alert.',
  unit21_alert_list: 'One page of alerts matching entity, case, status, tag or date filters.',
  unit21_alert_note_create: 'Adds a note to an alert.',
  unit21_alert_update: 'Writes a disposition note or tags back to an alert, or moves it to another queue.',
  unit21_case_bundle_fetch: 'One case with its alerts and the entities on it.',
  unit21_case_fetch: 'The full record for one case.',
  unit21_case_list: 'One page of cases matching entity, alert, status, tag or date filters.',
  unit21_case_note_create: 'Adds a note to a case.',
  unit21_entity_fetch: 'The full record for one entity (customer).',
  unit21_transaction_export: 'Starts and downloads a Unit21 bulk export of the transactions for one entity.',
  unit21_event_fetch: 'The full record for one event (transaction or action).',
  unit21_instrument_fetch: 'The full record for one instrument (account, card or wallet).',
  unit21_rule_fetch: 'The detection rule behind an alert.',
};

const summariesByKind = new Map(Object.entries(TOOL_SUMMARIES).map(([kind, summary]) => [squashKind(kind), summary]));

const toolSummary = (kind: string, fallback: string): string => summariesByKind.get(squashKind(kind)) ?? fallback;

export { toolSummary };
